<template>
  <div class="x-misscenlist-box" style="margin:15px">

  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'datacenter1',
  data () {
    return {

    }
  },
  created() {

  },
  mounted(){

  },
  methods:{

  }
}
</script>

<style>
  .x-miss-tabbox .el-tabs__item{
    font-size: 16px;
  }.x-miss-tabbox .el-tabs__nav-wrap::after{
    height: 0;
  }.x-miss-tabbox .el-tabs__nav-wrap{
    margin-left: 10px;
  }.x-pagination{
    margin-top: 20px;
  }.x-misscenlist-box .el-table th.is-leaf{
    text-align: center;
  }.x-misscenlist-box .el-table thead tr th{
    background-color: #F2F2F2;
  }.x-misscenlist-box .el-table td{
    text-align: center;
  }.x-misscenlist-box .el-tabs__nav-wrap::after{
    height: 0;
  }.x-text-see{
    color: #BDA17A;
    text-decoration: none;

  }.x-ac-remove {
      background: url(../images/change.png)no-repeat;
      background-size: contain;
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      padding-left: 25px;
      margin-right: 20px;
  }.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
    cursor: pointer;
  }.x-miss-addbox{
    text-align: left;
    margin-bottom: 15px;
  }.el-form-item__content{
    text-align: left;
  }.x-all-btn {
      margin: 30px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn {
      background-color: #BDA17A;
      font-size: 14px;
      color: #fff;
      text-align: center;
      height: 44px;
      line-height: 44px;
      width: 126px;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      margin-right: 20px;
      z-index: 0;
  }.x-btn-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn-right .x-search-input{
    width: auto;
    margin-right: 10px;
    /* float: left; */
  }.x-miss-li{
    color: #333;
    cursor: pointer;
  }.x-bianji{
    /* background: url(../images/change.png)no-repeat; */
    background-size: contain;
    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 20px;
    display: initial;
    color: #BDA17A;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter6.vue